import { cn } from '../../utils/cn'

// Card "Nota importante" + pilares de atuação (frame 585:5947 / Frame 117):
// nota em card com gradiente, label, callout com barra lateral e N cards de
// pilar com ícone (componente lucide passado em `icon`).
// pillars: array de { icon, title, text }
export default function ValuePillarsCard({
  noteTitle = '',
  note = '',
  pillarsLabel = '',
  callout = '',
  pillars = [],
  accentBorderClass = 'border-[#2862B9]',
  accentIconClass = 'text-[#2862B9]',
}) {
  return (
    <div className="w-full px-20 pb-16">
      <div className="flex flex-col gap-[26px] rounded-[10px] border border-[#E5E7EB] bg-gradient-to-br from-[#F9FAFB] to-white p-6">
        <div className="flex flex-col gap-[13px]">
          {noteTitle && (
            <h3 className="max-w-[557px] font-inter-bold text-2xl leading-9 text-[#454545]">
              {noteTitle}
            </h3>
          )}
          {note && (
            <p className="whitespace-pre-line font-inter-regular text-base leading-[26px] text-[#364153]">
              {note}
            </p>
          )}
        </div>

        <div className="flex flex-col gap-[26px]">
          <div className="flex flex-col gap-[13px]">
            {pillarsLabel && (
              <p className="font-inter-semibold text-lg leading-5 text-[#454545]">
                {pillarsLabel}
              </p>
            )}
            {callout && (
              <div className={cn('border-l pl-7', accentBorderClass)}>
                <p className="font-inter-bold text-lg leading-[1.08] tracking-[-0.02em] text-[#454545]">
                  {callout}
                </p>
              </div>
            )}
          </div>

          {pillars.length > 0 && (
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-[77px]">
              {pillars.map((pillar, index) => {
                const Icon = pillar.icon

                return (
                  <div
                    key={index}
                    className="flex flex-col gap-1 rounded-[10px] bg-[#EFF7FF] py-4 pr-4 pl-6"
                  >
                    <div className="flex items-center gap-2.5">
                      {Icon && (
                        <Icon size={28} className={cn(accentIconClass)} />
                      )}
                      <span className="font-inter-semibold text-base leading-5 text-[#454545]">
                        {pillar.title}
                      </span>
                    </div>
                    <p className="font-inter-regular text-base leading-[21px] text-[#364153]">
                      {pillar.text}
                    </p>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
